/**
 * Critical Assets Configuration
 *
 * Hardcoded URLs for assets needed at initial page load. These bypass
 * mediadb on first render for instant display; the media service
 * verifies/updates them in the background.
 */

export const LANDING_BACKGROUND_URL =
  'https://firebasestorage.googleapis.com/v0/b/the-home-ceo.firebasestorage.app/o/media%2Fcalm_water_background.webp?alt=media';

export const LANDING_BACKGROUND_ASSET_NAME = 'calm_water_background';
